<template>
	<div class="zjxPageFooter">
		<div class="zjxPageFooter_center">
			<!--<div class="zjxFooter_view">
				<p>平台技术由杭州新中大科技股份有限公司提供</p>
				<p>{{basicInfo.icp}}</p>
				<p>电话：{{basicInfo.cellphone}}</p>
			</div>-->
			<div class="zjxFooter_view">
				<p>{{basicInfo.copyright_owner}} &nbsp;&nbsp;&nbsp;{{basicInfo.icp}} &nbsp;&nbsp;&nbsp;技术支持：新中大科技</p>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		getBasicInfo,
	} from '../api/moudles/user.js'
	export default {
		data() {
			return {
				basicInfo: {},
			}
		},
		created() {
			this.getBasicInfo()
		},
		methods: {
			// 获取基本信息
			async getBasicInfo() {
				await getBasicInfo({
					data: {
						column_code: '5F8B3D07-841C-E204-58D9-3FF4BCEE4765'
					},
					success: res => {
						this.basicInfo = res.data
					}
				})
			},
		}
	}
</script>

<style scoped>
	.zjxPageFooter {
		width: 100%;
		height: 100px;
		background-color: #444546;
	}

	.zjxPageFooter_center {
		padding-top: 20px;
		width: 1200px;
		margin: 0 auto;
		display: flex;
		flex-flow: column;
		align-items: center;
		justify-content: space-between;
	}

	.zjxFooter_view {
		margin: 5px 0;
		display: flex;
	}
	.zjxFooter_view p{
		margin-right: 10px;
		color: #B5B5B5;
		font-family: PingFangSC-Regular;
		font-size: 14px;
		letter-spacing: 0;
		font-weight: 400;
	}
</style>
